import { newFrontendGuard } from './new-banking.guard';

/** `newFrontendGuard` for document signer pages, on the DocumentSigner version cookie. */
export const newDocumentSignerGuard = newFrontendGuard(partner => partner.documentSignerVersionCookie);
